import type { DescriptionsProps } from 'antd'
import { Descriptions } from 'antd'
import { search } from 'jmespath'
import { useEffect, useState } from 'react'
import { descriptionsSchema } from '../schemas/descriptions'
import { useDataStore } from '../stores'
import { withParsedData } from './base'

export const DescriptionsRenderer = withParsedData(descriptionsSchema)(({ parsedData }) => {
  const { title, dataSource, dataIndex, storeIdRef, ...rest } = parsedData
  const { dataMap } = useDataStore()
  const [items, setItems] = useState<DescriptionsProps['items']>([])

  useEffect(() => {
    let _dataSource

    if (typeof dataSource === 'object') {
      _dataSource = dataSource
    } else if (storeIdRef) {
      _dataSource = dataMap.get(storeIdRef)
    }

    _dataSource = dataIndex ? search(_dataSource, dataIndex) : _dataSource

    const _items: DescriptionsProps['items'] = _dataSource?.map(
      (item: { label: string | number; value: string | number }) => ({
        key: item.label,
        label: item.label,
        children: item.value,
      }),
    )

    setItems(_items)
  }, [dataMap])

  return <Descriptions {...rest} title={title} items={items} />
})
